export const websocket = {
    data () {
        return {
            websocket: null
        }
    },
    methods: {
        startWebsocket (path, cnes, token) {
            if (!this.websocket || this.websocket.readyState === 3) this.conectaWebsocket(path, cnes, token)
        },
        conectaWebsocket (path, cnes, token) {
            let wsUri = `wss://campograndems.labinovaapsfiocruz.com.br/wss/censo/${path}/${cnes}?token=${token}`
            this.websocket = new WebSocket(wsUri);
            
            let self = this;
            this.websocket.onopen = function() { 
                self.$store.commit('sessao/setWsAtivo', true)
                console.log('websocket ativo no cnes ' +  cnes);
            };

            this.websocket.onclose = function() {
                self.$store.commit('sessao/setWsAtivo', false)
                console.log('websocket desconectado :/');
            };

            this.websocket.onmessage = (resp) => {
                let resposta = JSON.parse(resp.data) 
                let dados = JSON.parse(resposta.dados)

                // console.log(dados)
       
                // Atualiza mapa de leitos commit('updateLeito', payload.dados)
                if (resposta.op == "censo") this.$store.commit('leitos/updateLeito', dados)
                if (resposta.op == "AIHsInternacao") this.$store.commit('leitos/updateAihs', dados)

                if (resposta.op == "desativarLeito") this.$store.commit('leitos/desativarLeito', dados)
                if (resposta.op == "ativarLeito") this.$store.commit('leitos/ativarLeito', dados)
                if (resposta.op == "inserirLeito") this.$store.commit('leitos/inserirLeito', dados)
                
                // commit('updateUltimaValidacao', payload.dados)
                if (resposta.op == "ultimaValidacao") this.$store.commit('informacoes/updateUltimaValidacao', dados)
                if (resposta.op == "ultimaInternacao") this.$store.commit('informacoes/updateUltimaInternacao', dados)
            };
        },
        desconectaWebsocket () {
            if (this.websocket && this.websocket.readyState === 1) this.websocket.close()
        }
    }
}